'use strict';

var FlightGridsDirective = function FlightGridsDirective() {
  return {
    restrict: 'E',
    controller: 'FlightGridsController',
    template: require('../templates/flight-grids.html'),
    scope: true,
    screenState: '='
  };
};
FlightGridsDirective.$inject = [];
module.exports = FlightGridsDirective;